// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__34BwS","log":"ModalInventoryLogs_log__3WTqB","date":"ModalInventoryLogs_date__JZXtq","userName":"ModalInventoryLogs_userName__usIwn"};